<template>
  <div>

  <div class="d-print-none d-none menu_scores" :class="$mq"> <!-- Menu for screen -->
    <div class="resultBar d-flex flex-row  justify-content-center fixed-top">
      <div class="categoryCard px-2" v-for="(cat, idx) in surveyCategories">
        <div class="title_box text-center">
          <div class="subtitle_heading">{{cat.name}}</div>
          <div class="current_page">{{idx+1}}</div>
        </div>
        <div class="w-100"></div>
        <div class="progress">
          <div class="progress-bar"
            role="progressbar"
            :style="{ 'width': (100*cat.userScore/cat.maxScore)+'%'}"
            :class="{
              'bg-success': (cat.userScore/cat.maxScore>0.66),
              'bg-warning': (cat.userScore/cat.maxScore<=0.66 && cat.userScore/cat.maxScore>0.33),
              'bg-error': (cat.userScore/cat.maxScore<=0.33)
            }"
            :aria-valuenow="100*cat.userScore/cat.maxScore"
            aria-valuemin="0"
            aria-valuemax="100">{{100*cat.userScore/cat.maxScore | number}}%</div>
        </div>
        <div class="w-100"></div>
        <div class="opinion"
        :class="{
              'color-success': (cat.userScore/cat.maxScore>0.66),
              'color-warning': (cat.userScore/cat.maxScore<=0.66 && cat.userScore/cat.maxScore>0.33),
              'color-error': (cat.userScore/cat.maxScore<=0.33)
            }">
          <span v-if="(cat.userScore/cat.maxScore>0.66)">{{$t('front_end.result_mini_score_good')}}</span>
          <span v-if="(cat.userScore/cat.maxScore<=0.66 && cat.userScore/cat.maxScore>0.33)">{{$t('front_end.result_mini_score_medium')}}</span>
          <span v-if="(cat.userScore/cat.maxScore<=0.33)">{{$t('front_end.result_mini_score_bad')}}</span>
        </div>
      </div>
    </div>
  </div> <!-- /Menu for screen -->

  <div class="row justify-content-center p-3 text-center editorial" ref="editorialElement">
    <div class="col-md-8 pt-4">
      <!-- <h1 class="cover-heading">{{$t('front_end.your_score')}}</h1>
      <h2 class="cover_score">{{userScorePercent | number}} %</h2> -->

      <!-- <radarchart :height="heightRadar"></radarchart> -->

      <div style="margin-top: 10px">&nbsp;</div>

      <div class="text-center mb-4" v-if="loading !== true && link_is_loaded !== true">
        <a @click="loading = true; redirectToPDFv2(quizId)" class="btn btn-secondary"><i class="fa fa-download" aria-hidden="true"></i> {{$t('front_end.download_pdf')}}</a>
      </div>
      <div class="text-center mb-4" v-if="loading === true && link_is_loaded !== true">
        <a @click="loading = true" class="btn btn-secondary"><i class="fa fa-download" aria-hidden="true"></i> {{$t('front_end.pdf_generation')}} <i class="ml-2 fa fa-spinner fa-spin"></i></a>
      </div>
      <div class="text-center mb-4" v-if="link_is_loaded">
        <a :href="pdfLink" class="btn btn-secondary"><i class="fa fa-download" aria-hidden="true"></i> {{$t('front_end.download_pdf')}}</a>
      </div>

      <h1 class="company_name text-white">{{profile.company}}</h1>
    </div>

  </div>
  <div class="row">
    <render-result-section
      v-for="(categoryObject, idx) in survey.quizList"
      :categoryObject=categoryObject
      :score=surveyCategories[idx]
      :sectionCount=sectionCount
      :categoryIdx=idx
      :key=idx
      ></render-result-section>
  </div>

<!--     <div class="row justify-content-center pb-5 text-center ">
      <div class="col-md-8 pt-4">
        <h2 class="cover_subheading">Votre bilan personnalisé vous sera envoyé par email au format PDF.</h2>
      </div>
    </div> -->

   <footer class="action_bar" ref="actionBar">
      <div class="action_bar_parent">
        <div class="contact_expert px-3">
          <a
          :href="$options.filters.translategrader(settings.copy.expert_callback_link, $i18n.locale)"
          target="_blank"> <img src="@/assets/img/plus_circled.svg" height="25" class="pr-2 mb-1"/>  {{settings.copy.expert_callback_text  | translategrader($i18n.locale)}}</a>
        </div>
        <div class="px-3 recommencer d-none d-md-block" data-toggle="modal" data-target="#restartDiag" >
          <img src="@/assets/img/recommencer.svg" height="20"/> {{$t('front_end.restart')}}
        </div>
      </div>
    </footer>

    <div class="modal fade" id="restartDiag" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{$t('front_end.restart_modal_title')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{$t('front_end.restart_modal_text')}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal">{{$t('front_end.restart_dismiss')}}</button>
            <button type="button" class="btn btn-warning" @click="clearAndGoHome" data-dismiss="modal"><i class="fa fa-exclamation-triangle"></i> {{$t('front_end.restart')}}</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex';
  import Radarchart from '@/components/RadarChart.vue'
  import RenderResultSection from '@/components/RenderResultSection.vue'

  import {
    UPDATE_PROFILE
  } from '@/store/lead/mutations';

  export default {
    name: 'results-web',

    components: {
      Radarchart,
      RenderResultSection
    },



    async created() {
      // get the quiz using the id passed in url params
      if (this.$route.params.id !== undefined){
        this.quizId = this.$route.params.id;
        var payload = {docID: this.quizId};

        await this.getSurveyFromID(payload);

        // Now we have info from the survey, and especially the email from the lead. Let's import the lead's information
        payload = {email: this.survey.email};
        await this.getLeadFromEmail(payload);

        let totalScore = 0;
        let userScore = 0;
        for (let category of this.surveyCategories) {
          // Compute total score
          totalScore += parseInt(category.maxScore);
          userScore += parseInt(category.userScore);

          // Prepare the dict for radarChart
          this.computedScores[category.name] = {};
          this.computedScores[category.name]["percent"] = 100 * parseInt(category.userScore) / parseInt(category.maxScore);
        }

        // update total score data
        this.userScorePercent = 100 * userScore / totalScore;

        // When lead is ready, trigger notifications and connect to Hubspot and notify Slack

        // If we use a query "revue" we don't notify on Slack again and we don't send to Hubspot
        if (this.$route.query.revue === "1" || process.env.NODE_ENV === 'development') {
          console.log("we should not notify");
        } else {
          // this.alertOnZapier()
          //this.alertOnSlack()
          //this.sendLeadToHubspot()
        }

      }

    },

    // mounted () {
    //   var editorial_element = this.$refs.editorialElement;
    //   var lowest_bound = editorial_element.getBoundingClientRect().bottom;//+$(window);.scrollY;
    //   console.log("Lowest bound: ", lowest_bound);
    //   var action_bar_element = this.$refs.actionBar;
    //   action_bar_element.style.bottom = lowest_bound;
    // },

    data() {
      return {
        quizId: "",
        userScorePercent: 0,
        computedScores: {},
        // PDF generation
        loading: false,
        link_is_loaded: false,
        resultAPI: "",
        pdfLink: "",

      }
    },

    filters: {
      number(floatNumber){
          return Math.round(floatNumber);
      }
    },

    computed: {
      ...mapGetters({
        profile: 'lead/profile',
        survey: 'survey/survey',
        surveyCategories: 'survey/categories',
        settings: 'settings/settings',
      }),

      sectionCount(){
        return this.surveyCategories.length;
      },

      heightRadar() {
        return this.$mq === 'sm'
        ? 300
        : 500
      }

    },

    methods: {
      ...mapMutations('lead', {
        updateProfile: UPDATE_PROFILE,
        saveProfileDB: UPDATE_PROFILE,
        }),

      ...mapActions({
        getSurveyFromID: 'survey/getSurveyFromID',
        getLeadFromEmail: 'lead/getLeadFromEmail',
      }),

      ...mapActions({clearAll: 'clearAll'}),

      clearAndGoHome(){
        this.clearAll();
        this.$router.push('/');

      },

      // computeCategories() {
      //   for (var categoryIdx in this.survey.quizList) {
      //     let categoryObject = this.survey.quizList[categoryIdx];
      //     this.categories.push(categoryObject.title);
      //   }
      //   console.log(this.categories);
      //   return;
      // }

      async alertOnSlack() {

        var priorities = "";
        for (var prio of this.profile.priorities) {
          if (prio.checked) {
            if (priorities != "") {
              priorities += " - "
            }
            priorities += prio.name ;
          }
        }

        var slackUrl = "https://hooks.slack.com/services/special_setting";
        var payload={
          "text": "[Autodiag] Le lead vient de finir son autodiag et consulte ses résultats :\n"
          + " URL : " + "https://www.okedito.com/diagnostic-inbound-marketing/?#/resultats/" + this.$route.params.id + "?revue=1 \n"
        + "Entreprise : " + this.profile.company + "\n"
        + "Nom : " + this.profile.firstName + " " + this.profile.lastName + " (" + this.profile.email + ")\n"
        + "Projet : " + priorities + " (horizon : " + this.profile.projectDeadline + ")\n"
        + "Score (global) : " + JSON.stringify(Math.round(this.userScorePercent)) + "%\n\n"
        //+ "Merci de télécharger le PDF généré sur cette page https://www.okedito.com/diagnostic-inbound-marketing/?#/pdf/" + this.$route.params.id + " puis de l'uploader sous Google Drive. Enfin, remplir, dans la fiche Hubspot du nouveau lead, le champ `Résultats Autodiag - URL PDF`."
      }
        try {
          await axios.post(slackUrl,
            JSON.stringify(payload), {
            withCredentials: false,
            transformRequest: [(data, headers) => {
              delete headers.post["Content-Type"] // See https://stackoverflow.com/a/49248026/2550237
              return data
            }]
          }
        )}
        catch (e) {
          console.log("Error while posting to Slack: ", e)
          // this.errors.push(e)
        }
      },

      async alertOnZapier() {

        var currentPage = this.$route.params.pageNumber ;

        var priorities = "";
        for (var prio of this.profile.priorities) {
          if (prio.checked) {
            if (priorities != "") {
              priorities += " - "
            }
            priorities += prio.name ;
          }
        }

        var apiUrl = "https://hooks.zapier.com/hooks/catch/special_setting/";
        var payload={
          "profile": this.profile,
          "priorities": priorities,
          "score_global": Math.round(this.userScorePercent),
          "scores": this.computedScores,
          "url": "https://www.okedito.com/diagnostic-inbound-marketing/?#/resultats/" + this.$route.params.id
        }
        try {
          await axios.post(apiUrl,
            JSON.stringify(payload), {
            withCredentials: false,
            transformRequest: [(data, headers) => {
              delete headers.post["Content-Type"] // See https://stackoverflow.com/a/49248026/2550237
              return data
            }]
          }
        )}
        catch (e) {
          console.log("Error while posting to Zapier: ", e)
          // this.errors.push(e)
        }
      },

      async sendLeadToHubspot() {
        // Documentation : https://developers.hubspot.com/docs/methods/forms/submit_form_v3

        // We only send the email to hubspot this way on this page
        // Then, the rest is sent via Zapier on result page

        var apiUrl = "https://api.hsforms.com/submissions/v3/integration/submit/special_setting"

        var priorities = "";
        for (var prio of this.profile.priorities) {
          if (prio.checked) {
            if (priorities != "") {
              priorities += " - "
            }
            priorities += prio.name ;
          }
        }

        var timeline = "";
        switch(this.profile.projectDeadline) {
          case "Oui, avant 3 mois":
              timeline = "Moins de 3 mois"
              break;
          case "Oui, d'ici 3 à 6 mois":
              timeline = "Entre 3 et 6 mois"
              break;
          case "Oui, d'ici 6 à 12 mois":
              timeline = "Entre 6 et 12 mois"
              break;
          case "Non, pas avant 12 mois":
              timeline = "Après 12 mois"
              break;
          default:
              break;
        }

        var postData = {
            "fields":
            [
              {
                "name": "email",
                "value":  this.survey.email
              },
              {
                "name": "has_finished_autodiag",
                "value":  true
              },
              {
                "name": "piorites_12_prochains_mois",
                "value":  priorities
              },
              {
                "name": "score_attraction",
                "value":  this.computedScores["Attraction"].percent
              },
              {
                "name": "score_closing",
                "value":  this.computedScores["Closing"].percent
              },
              {
                "name": "score_conversion",
                "value":  this.computedScores["Conversion"].percent
              },
              {
                "name": "score_fidelisation",
                "value":  this.computedScores["Fidélisation"].percent
              },
              {
                "name": "score_strategie",
                "value":  this.computedScores["Stratégie"].percent
              },
              {
                "name": "score_technique",
                "value":  this.computedScores["Technique"].percent
              },
              {
                "name": "score_global",
                "value":  Math.round(this.userScorePercent)
              },
              {
                "name": "timing",
                "value":  timeline
              },
              {
                "name": "url_page_resultat",
                "value":  "https://www.okedito.com/diagnostic-inbound-marketing/?#/resultats/" + this.$route.params.id
              },
              {
                "name": "url_pdf",
                "value":  "https://www.okedito.com/diagnostic-inbound-marketing/?#/pdf/" + this.$route.params.id
              }
            ],
            "skipValidation": true
        };


        try {
          console.log("posting to hubspot");
          await axios.post(apiUrl,
            JSON.stringify(postData), {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )}
        catch (e) {
          console.log("Error while posting to Hubspot: ", e)
          // this.errors.push(e)
        }
      },

      async redirectToPDF(documentID) {
        // We are making use of https://portal.api2pdf.com/
        // Documentation: https://app.swaggerhub.com/apis-docs/api2pdf/api2pdf/1.0.0#/Headless%20Chrome/chromeFromUrlPost
        //
        // Generate the PDF via external service
        // Download it via browser

        var currentComponent = this;
        var postedJson = {};
        let pdfPageRoute = this.$router.resolve({ name: 'PDF results',
          params: { id: documentID, lang: this.$i18n.locale },
        });
        console.log("redirectToPDF : ", process.env.VUE_APP_ROOT_FOLDER)
        postedJson["url"] = process.env.VUE_APP_ROOT_FOLDER + pdfPageRoute.href;
        console.log("Router redirectToPDF path : ", process.env.VUE_APP_ROOT_FOLDER + pdfPageRoute.href)
        postedJson["inlinePdf"] = false;
        postedJson["fileName"] = "result_quiz.pdf";

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'downloadAutodiagPDF'
        });

        axios.post("https://v2018.api2pdf.com/chrome/url", postedJson, { headers: { Authorization: "8d3f5d17-4d4f-47c2-b533-4d46ae72e190" }}).then(function(response){
            currentComponent.resultAPI = response;
            currentComponent.pdfLink = response.data.pdf;
            console.log(response.data.pdf);
            currentComponent.link_is_loaded = true;

            // If we were already waiting for the ressource, we automatically open it at the end
            if (currentComponent.loading) {
              window.location.href =response.data.pdf;
            }
        }).catch( function(error){
            currentComponent.error = true;
            currentComponent.link_is_loaded = true;
        });


      },


      async redirectToPDFv2(documentID) {
        // We are making use of https://portal.api2pdf.com/
        // Documentation: https://app.swaggerhub.com/apis-docs/api2pdf/api2pdf/1.0.0#/Headless%20Chrome/chromeFromUrlPost
        //
        // Generate the PDF via external service
        // Download it via browser
        //
        // May 2020
        // New API : https://www.api2pdf.com/resolved-pdf-is-rendering-blank-or-only-partially-with-headless-chrome/

        var currentComponent = this;
        var postedJson = {};
        let pdfPageRoute = this.$router.resolve({ name: 'PDF results',
          params: { id: documentID, lang: this.$i18n.locale },
        });
        console.log("redirectToPDF : ", process.env.VUE_APP_ROOT_FOLDER)
        // postedJson["url"] = process.env.VUE_APP_ROOT_FOLDER + pdfPageRoute.href;
        postedJson["url"] = process.env.VUE_APP_ROOT_FOLDER + pdfPageRoute.href;
        console.log("Router redirectToPDF path : ", process.env.VUE_APP_ROOT_FOLDER + pdfPageRoute.href)
        postedJson["inline"] = false;
        var fileName = "report_" + (this.settings.brand.brand_name).replace(/\s+/g, '-').toLowerCase() + ".pdf"; // Todo next : use this for filename
        postedJson["fileName"] = fileName;
        postedJson["options"] = {};
        postedJson["options"]["delay"] = 3000;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'downloadAutodiagPDF'
        });

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': '8d3f5d17-4d4f-47c2-b533-4d46ae72e190'
        }

        axios.post("https://v2.api2pdf.com/chrome/pdf/url", postedJson, { headers: headers}).then(function(response){
          console.log("Jice : ", response.data);
          // var responseDataJSON = JSON.parse(response.data);
          var responseDataJSON = response.data;
          console.log("Joce :", responseDataJSON);
          console.log("URL : ", responseDataJSON.FileUrl);
            currentComponent.resultAPI = responseDataJSON;
            currentComponent.pdfLink = responseDataJSON.FileUrl;
            currentComponent.link_is_loaded = true;

            // If we were already waiting for the ressource, we automatically open it at the end
            if (currentComponent.loading) {
              window.location.href = responseDataJSON.FileUrl;
            }
        }).catch( function(error){
            currentComponent.error = true;
            currentComponent.link_is_loaded = true;
        });


      },

    }
  }
</script>


<style scoped>

.row {
  background: #fff;
}

.resultBar {
background: #F4F5F6;
height: 92px;
width: 100%;
border-bottom: 1px solid #E6E6E6;
top: 68px;
}

.categoryCard {
  max-width: 160px!important;
  background: #F3F4F5;
  opacity: 1;
  border-left: 1px solid #E6E6E6;
}

.categoryCard:last-child {
  border-right: 1px solid #E6E6E6;
}


.title_box {
  position: relative;
}

.title_box .subtitle_heading {
  position: relative;
  text-align: center;
  color: #404040;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 16px;
  margin-top: 15px;
  z-index: 9999!important;
}

.title_box .current_page {
  margin-top: -50px;
  margin-bottom: -10px;
  text-align: center;
  color: #404040;
  font-family: 'andale mono', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 52px;
  opacity: 0.2;
}

.progress {
  border-radius: 8px;
  border: #dbdbdb 1px solid;
  height: 15px;
  background-color: #fff;
}

.bg-success {
  background-color: #139A43!important;
}
.bg-warning {
  background-color: #FC8F00!important;
}
.bg-error {
  background-color: #DC0000!important;
}

.color-success {
  color: #139A43!important;
}
.color-warning {
  color: #FC8F00!important;
}
.color-error {
  color: #DC0000!important;
}

.editorial {
  background-color: var(--colorPrimary);
}

.opinion {
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  text-align: center;
}

.company_name {
  font-family: 'Nunito', sans-serif;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
}

.cover-heading {
  font-family: 'Nunito', sans-serif;
  font-weight: normal;
  font-size: 32px;
  color: #00AFF0;
}
.cover_subheading, .cover_score {
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  font-size: 40px;
  color: #00AFF0;
}

.cover_score {
  font-size: 40px;
  color: #000;
  padding-bottom: 38px;
}

.cover-lead{
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
}
.cover-lead a {
  color: #00AFF0;
  font-weight: 600;
  text-decoration: underline;
}

.action_bar {
  position: sticky;
  bottom: 0;
  /*width: 100%;*/
  display: flex;
  flex-wrap: wrap;
  background: var(--colorPrimary);
  color: #fff;
  /*height: 42px;*/
  line-height: 42px;
  z-index: 1000;
  margin-left: -15px;
  margin-right: -15px;
}

.action_bar_parent {
  position: relative;
  width: 100%;
  height: 42px;
}

.action_bar_parent .contact_expert {
  position: absolute;
  background-color: var(--colorSecondary);
  font-size: 18px;
  left: 50%;
  transform: translate(-50%, 0%);
  cursor: pointer;
  color: #051e41;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
}

.action_bar_parent .contact_expert a {
  color: #252525;
  text-decoration: none;
}

.action_bar_parent .recommencer {
  position: absolute;
  right: 0%;
  /*transform: translate(-100%, 0%);*/
  background: #707070;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}

.action_bar a {
  color: #fff;
  text-decoration: underline;
}

.action_bar .bord_fenetre {
  max-width: 200px;
}

.btn {
  cursor: pointer;
}

.btn-light {
  background-color: #eee;
}

@media only screen and (max-width: 710px) {
  .menu_scores {
    display: none;
  }

  .editorial {
    margin-top: 80px;
  }
}

@media only screen and (max-width: 768px) {

  .editorial {
    margin-top: 70px;
  }

  .cover_score {
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .action_bar .contact_expert {
    font-size: 12px;
    line-height: 1em;
    height: 42px;
    text-align: right;
  }
}

.menu_scores.sm {
  display: none;
}

.btn-secondary {
  text-transform: uppercase;
  font-family: Montserrat,sans-serif;
  font-weight: 700;
  padding-top: 14px;
  padding-bottom: 14px;
}

</style>



// WEBPACK FOOTER //
// src/pages/results/ResultsWebPage.vue